import { render, staticRenderFns } from "./VueFluxSlider.vue?vue&type=template&id=af04ed66"
import script from "./VueFluxSlider.vue?vue&type=script&lang=js"
export * from "./VueFluxSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports